import * as React from "react";
import Image from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Image/Image";

const LogoBlock = ({ settings, className = '', isMobile }) => {
    const logoWidth = settings?.additional?.logo_width || '3rem';
    const logoWidthMobile = settings?.additional?.logo_width_mobile || logoWidth;
    const appliedWidth = isMobile ? logoWidthMobile : logoWidth;

    return (
        <div className={`header-logo-container  ${className} `}>
            <a href="/" className={`header-logo-image lg:pb-0`} style={{ width: appliedWidth }}>
              <Image imageUrl={settings.additional.logo}/>
            </a>

            <a href="/" className="header-logo">
                {settings.additional.shop_title}
            </a>
        </div>
    )
}

export default LogoBlock;